import { I18n } from '@calendly/i18n'
import { useEffect, useCallback } from 'react'

import { TimingErrorMessage, TimingInputBlock, TimingSelect, TimingTextField } from './styles'

const unitLimits = {
  days: 999,
  hours: 720,
  minutes: 43200
}
const unitTypes = Object.keys(unitLimits)

export const TimingInput = ({
  value,
  units,
  onChange,
  onError = (() => { }),
  notZero = false
}) => {
  // i18n-tasks-use t('publisher.workflows.forms.trigger.units.#{unit}')
  const isError = useCallback(() => (notZero && value === 0), [notZero, value])
  const timingUnitsOptions = unitTypes.map((unit) => ({
    id: unit,
    name: I18n.t(`publisher.workflows.forms.trigger.units.${unit}`)
  }))
  const { name } = timingUnitsOptions.find(({ id }) => id === units)

  useEffect(() => {
    onError(isError())
  }, [isError, onError])

  function onChangeWithLimits(newValue, newUnits) {
    onChange(
      Math.min(unitLimits[newUnits], newValue),
      newUnits
    )
  }

  function onValueChange(event) {
    if (event.target.value.match(/^\d*$/) === null) {
      return
    }
    onChangeWithLimits(event.target.value, units)
  }

  function onUnitsChange(newUnits) {
    onChangeWithLimits(value, newUnits)
  }

  return (
    <>
      <TimingInputBlock>
        <TimingTextField
          value={value}
          onChange={onValueChange}
          maxLength={5}
          errors={isError() ? [''] : []}
          aria-label={name}
        />
        <TimingSelect
          aria-label={I18n.t('publisher.workflows.triggers.custom_unit_label')}
          value={units}
          onChange={onUnitsChange}
          options={timingUnitsOptions}
        />
      </TimingInputBlock>
      {isError() && <TimingErrorMessage message={I18n.t('publisher.workflows.forms.not_zero')} />}
    </>
  )
}
